// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dvd_","tabsBox":"styles_tabsBox__2FElc","createButton":"styles_createButton__2cvcJ"};